import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon, Button, Badge, Card, CardBody } from '@repo/ui';

interface WebhookCardProps {
  title: string;
  description: string;
  iconColor: 'blue' | 'green';
  isActive: boolean;
  manageRoute: string;
  activityRoute: string;
  features?: Array<{ icon: string; label: string }>;
}

export const WebhookCard: React.FC<WebhookCardProps> = ({
  title,
  description,
  iconColor,
  isActive,
  manageRoute,
  activityRoute,
  features = [],
}) => {
  const navigate = useNavigate();

  const colorClasses = {
    blue: {
      bg: 'bg-blue-100 dark:bg-blue-900/30',
      icon: 'text-blue-600 dark:text-blue-400',
    },
    green: {
      bg: 'bg-green-100 dark:bg-green-900/30',
      icon: 'text-green-600 dark:text-green-400',
    },
  };

  const colors = colorClasses[iconColor];

  return (
    <Card padding="lg" variant="outlined">
      <CardBody>
        <div className="flex items-start space-x-4">
          <div className={`flex-shrink-0 p-3 ${colors.bg} rounded-xl`}>
            <Icon name="HiGlobe" className={`h-8 w-8 ${colors.icon}`} />
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between mb-2">
              <h3 className="text-xl font-semibold text-xtnd-dark-800 dark:text-white">{title}</h3>
              {isActive && (
                <Badge variant="success" className="text-xs ml-2">
                  Active
                </Badge>
              )}
            </div>
            <p className="text-sm text-xtnd-dark-500 dark:text-xtnd-dark-300 mb-4">{description}</p>

            {features.length > 0 && (
              <div className="flex items-center space-x-4 text-xs text-xtnd-dark-400 dark:text-xtnd-dark-300 mb-4">
                {features.map((feature, index) => (
                  <div key={index} className="flex items-center space-x-1">
                    <Icon name={feature.icon as any} className="h-4 w-4" />
                    <span>{feature.label}</span>
                  </div>
                ))}
              </div>
            )}

            <div className="flex items-center space-x-2">
              <Button
                onClick={() => navigate(manageRoute)}
                variant="primary"
                size="sm"
                leftIcon={<Icon name="HiCog" className="h-4 w-4" />}
              >
                Configure
              </Button>
              <Button
                onClick={() => navigate(activityRoute)}
                variant="outline"
                size="sm"
                leftIcon={<Icon name="HiEye" className="h-4 w-4" />}
              >
                View Activity
              </Button>
            </div>
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

